import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { notesActionTypes } from '../reducer';

function* getNotes() {
  yield requestSaga({
    actionType: notesActionTypes.getList,
    request: dataProvider.getList,
    resource: resources.specialNote.index,
  });
}

export default getNotes;
